module.exports = __webpack_public_path__ + "static/gallery-img-32-03602ff52d68b35e121b551994c2d04d.jpg";